import { FormattedMessage } from "react-intl";
import CopyButtonWithFeedback from "./CopyButtonWithFeedback.tsx";
import EditCopy from "common/icons/EditCopy.tsx";
import { useId } from "react";

export default function CopyInputWithButton({
  label,
  textToCopy,
}: {
  label?: string;
  textToCopy: string;
}) {
  const inputId = useId();

  return (
    <div className="vst-input-with-button">
      {label && <label htmlFor={inputId}>{label}</label>}
      <input value={textToCopy} readOnly id={inputId} />
      <CopyButtonWithFeedback textToCopy={textToCopy}>
        <EditCopy />
        <FormattedMessage defaultMessage="Copy" />
      </CopyButtonWithFeedback>
    </div>
  );
}
